<template>
  <zm-context :system-fonts="false" :namespace="NAME_SPACE">
    <try-new-experienceToggle v-if="showRollback" :enable="true" />

    <!-- <zm-button type="secondary" class="header-custom-link">Open App</zm-button> -->
    <meeting-shortcuts v-if="showMeetingShortcut" />

    <div id="upsell-cta" ref="upsellCtaTarget" class="header-upsell-cta"></div>

    <div v-if="showAicPanel" id="admin-ai-companion">
      <ai-companion class="header-aic-admin" />
    </div>
  </zm-context>
</template>

<script setup>
import { computed, nextTick, onMounted, ref } from 'vue'
import { ZmContext } from '@zoom/zoom-ui-vue3'
import TryNewExperienceToggle from '../../shared/try-new-experience/toggle.vue'
import { NAME_SPACE } from '@/commons/constants'
import AiCompanion from '../../ai-companion/ai-companion.vue'
import meetingShortcuts from './components/meeting-shortcuts.vue'
defineOptions({
  name: 'frame-header-right'
})

const props = defineProps({
  showRollback: Boolean,
  showAicPanel: {
    type: Boolean,
    default: false
  }
})
const upsellCtaTarget = ref(null)

const MEETING_SHORTCUT_PAGES = ['my-account', 'meetings', 'admin-center']

const showMeetingShortcut = computed(() => {
  const logoTextId = window.microsDatas?.logoTextId
  return logoTextId ? MEETING_SHORTCUT_PAGES.includes(logoTextId) : false
})
onMounted(() => {
  nextTick(() => {
    window.dispatchEvent(
      new CustomEvent('common-header:right-slots-mounted', {
        detail: {
          target: upsellCtaTarget.value
        }
      })
    )
  })
})
</script>

<style lang="scss">
.header-right-custom-item {
  margin-left: 16px;
  white-space: nowrap;
  color: inherit;
  &:hover {
    text-decoration: none;
  }
}
.header-right-custom-item + .header-right-custom-item {
  margin-left: 16px;
}
.header-upsell-cta {
  display: contents;
}

.billing-shopping-bag-wrapper .billing_opc_modal--iframe {
  background: #f7f7f8;
}

@media (max-width: 767px) {
  .header-upsell-cta {
    display: none;
  }
}
</style>
